import { render, staticRenderFns } from "./EditEventDialog.vue?vue&type=template&id=187496c2&scoped=true"
import script from "./EditEventDialog.vue?vue&type=script&lang=js"
export * from "./EditEventDialog.vue?vue&type=script&lang=js"
import style0 from "./EditEventDialog.vue?vue&type=style&index=0&id=187496c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187496c2",
  null
  
)

export default component.exports